import { Component, OnInit } from '@angular/core';
import { ToastsManager } from 'ng2-toastr';
import { BusinessRulesTypeEnum } from '../../../enums/businessRulesTypes.enum';
import { BusinessRulesInterface } from '../../../interfaces/business-rules.interface';
import { BusinessRulesService } from '../../../services/business-rules.service';
import { LoggerService } from '../../../services/logger.service';
import { BusinessRulesHelper } from '../business-rules-helper';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-business-rules-list',
  templateUrl: './business-rules-list.component.html',
  styleUrls: ['./business-rules-list.component.scss']
})
export class BusinessRulesListComponent implements OnInit {
  public businessRules: BusinessRulesInterface[];
  public selected: BusinessRulesInterface = {} as BusinessRulesInterface;
  public blockRulesTypes = BusinessRulesHelper.blockRulesTypes;
  public lengthRulesTypes = BusinessRulesHelper.lengthRulesTypes;
  isLoading = false;

  constructor(
    private toastr: ToastsManager,
    private businessService: BusinessRulesService,
    public translate: TranslateService
  ) {}

  ngOnInit() {
    this.businessRulesFetchAll();
  }

  getRule(type: BusinessRulesTypeEnum): BusinessRulesInterface {
    if (!this.businessRules) {
      return;
    }
    return this.businessRules.find(rule => rule.type === type);
  }

  updateStatus() {
    this.businessRulesFetchAll();
  }

  businessRulesFetchAll() {
    this.isLoading = true;

    this.businessService.fetchAll({}).subscribe(
      businessRules => {
        this.businessRules = businessRules;
        this.isLoading = false;
      },
      error => {
        LoggerService.log('ProductListComponent::ngOnInit', error);
        this.toastr.error(this.translate.instant('BUSINESS_RULES_LIST.COMPONENT.DATA_ERROR'));
        this.isLoading = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/business-rules/business-rules-list/business-rules-list.component.ts